import { lazy } from "react";

export const BranchPageContent = lazy(() => import("./BranchPageContent"));
